module.exports = __webpack_public_path__ + "img/cf247-app-icon-preview.d90748f1.png";